import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "review-wallet-modal" }
const _hoisted_2 = {
  key: 0,
  class: "review-wallet-container"
}
const _hoisted_3 = { class: "review-wallet-header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "review-wallet-header-title" }
const _hoisted_6 = { class: "review-wallet-header-subtitle" }
const _hoisted_7 = { class: "review-wallet-body" }
const _hoisted_8 = { class: "review-wallet-body-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "review-wallet-body-row-key" }, "Asset", -1)
const _hoisted_10 = { class: "review-wallet-body-row-value" }
const _hoisted_11 = { class: "review-wallet-body-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "review-wallet-body-row-key" }, "Network", -1)
const _hoisted_13 = { class: "review-wallet-body-row-value" }
const _hoisted_14 = { class: "review-wallet-body-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "review-wallet-body-row-key" }, "Wallet address", -1)
const _hoisted_16 = { class: "review-wallet-body-row-value" }
const _hoisted_17 = { class: "review-wallet-body-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "review-wallet-body-row-key" }, "Requested by", -1)
const _hoisted_19 = { class: "review-wallet-body-row-value" }
const _hoisted_20 = {
  key: 0,
  class: "review-wallet-body-row"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "review-wallet-body-row-key" }, "Wallet Memo", -1)
const _hoisted_22 = { class: "review-wallet-body-row-value" }
const _hoisted_23 = { class: "review-wallet-footer" }
const _hoisted_24 = { class: "review-wallet-button" }
const _hoisted_25 = { class: "review-wallet-button" }
const _hoisted_26 = {
  key: 1,
  class: "review-wallet-container"
}
const _hoisted_27 = { class: "review-wallet-logo" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "review-wallet-reason-title" }
const _hoisted_30 = { class: "review-wallet-reason-option-text" }
const _hoisted_31 = { class: "review-wallet-reason-option-radio" }
const _hoisted_32 = ["for"]
const _hoisted_33 = ["value", "id"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "radio-button" }, null, -1)
const _hoisted_35 = { class: "review-wallet-reason-other" }
const _hoisted_36 = { class: "review-wallet-reason-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_WidgetInput = _resolveComponent("WidgetInput")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      open: _ctx.showDialog,
      width: 460,
      onCloseDialog: _cache[5] || (_cache[5] = ($event: any) => {
        _ctx.$emit('closeDialog');
        _ctx.step = 1;
        _ctx.selectedReason = '';
        _ctx.enteredDenyReason = '';
      }),
      class: "z-4"
    }, {
      content: _withCtx(() => [
        (_ctx.step === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "flex mx-auto mb-8",
                  src: require('@/assets/walletCoins.svg'),
                  alt: "wallet logo"
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('reviewWalletModal.headingText')), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('reviewWalletModal.subHeadingText')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.address.cryptocurrency), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.address.network), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.address.address), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.address.createdBy), 1)
                ]),
                (_ctx.address.memo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.address.memo), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Button, {
                    text: "Deny",
                    radius: 10,
                    variant: "outline",
                    onButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step = 2)),
                    id: "review-wallet-deny"
                  })
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_Button, {
                    text: "Approve",
                    radius: 10,
                    onButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approveOrDenyWallet('approved'))),
                    id: "review-wallet-approve",
                    loader: _ctx.statusChanging
                  }, null, 8, ["loader"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.step === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("img", {
                  class: "flex mx-auto mb-8",
                  src: require('@/assets/handBlock.svg'),
                  alt: "Yellowcard Logo"
                }, null, 8, _hoisted_28)
              ]),
              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('reviewWalletModal.denyWalletHeader')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.denyWalletReasons, (reason) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: reason,
                  class: "review-wallet-reason-option"
                }, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(reason), 1),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", {
                      for: `${reason}`
                    }, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: "settlementNetwork",
                        value: `${reason}`,
                        id: `${reason}`,
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectReason && _ctx.selectReason(...args))),
                        class: "review-wallet-reason-option-radio-button"
                      }, null, 40, _hoisted_33),
                      _hoisted_34
                    ], 8, _hoisted_32)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_WidgetInput, {
                  type: "text",
                  id: "review-wallet-reason",
                  name: "review-wallet-reason",
                  "aria-label": "label",
                  placeholder: "Other",
                  modelValue: _ctx.enteredDenyReason,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enteredDenyReason) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_Button, {
                  text: "Submit",
                  radius: 10,
                  disabled: _ctx.isButtonDisabled,
                  onButtonClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.approveOrDenyWallet('denied'))),
                  id: "review-wallet-deny",
                  loader: _ctx.statusChanging
                }, null, 8, ["disabled", "loader"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}